
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/manage-cross-timezone-teams-communication",
      function () {
        return require("private-next-pages/article/manage-cross-timezone-teams-communication.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/manage-cross-timezone-teams-communication"])
      });
    }
  